import React from "react";
import Layout from "../components/Layout";
import {AboutImg, WBGLogoWhite, ESMAPLogoWhite, VidaLogoWhite} from "../components/Images";
import { Helmet } from "react-helmet";

export default function About() {

  return (
    <Layout>
     <Helmet>
       <title>Distributed Renewable Energy (DRE) Atlas - About</title>
       <meta name="description" content="Achieving Universal Electrification: Assessing Communities for Smart Investments" />
     </Helmet>
        <div id="about-container" className="about-grid">
            <div className="about-text">
                    <h1 className="text-yellow">About</h1>
                    <h5 className="page-description">Achieving Universal Electrification: Assessing Communities for Smart Investments</h5>
                    <div className="about-content">
                        <p>The Distributed Renewable Energy (DRE) Atlas is a publicly accessible, web-based, interactive platform offering comprehensive data on settlements in 58 countries. Designed for easy navigation, it empowers users to make informed investment decisions by providing detailed insights into communities potentially suitable for the deployment of DRE solutions and complementary appliances for the productive use of energy.</p>

                        <p>The DRE Atlas is intended to support initiatives like the World Bank and African Development Bank’s Mission 300, which aims to connect 300 million people in Africa to electricity and catalyze economic transformation, by providing governments and the private sector with a tool to better understand where DRE solutions may be appropriate and sustainably deployed.</p>

                        <p>Users can also apply filters to identify and prioritize sites within any country. Filters available include the region, the number of
                        buildings, the distance to existing energy infrastructure, the presence of light at night, and whether the settlement has main
                        road access. Filters can be combined, enabling users to identify settlements across the country that meet multiple criteria.</p>

                        <span>Key Features:</span>
                        <ul>
                            <li><span className="fw-bold">Comprehensive Data Access</span>: Explore over 60 high-resolution indicators per settlement, including number of potential electricity connections, building density, electricity and road access, economic and agricultural indicators, security.</li>
                            <li><span className="fw-bold">Advanced Filtering</span>: Tailor your search with filters like region, building count, proximity to energy infrastructure, nighttime lighting, and road access to pinpoint ideal sites.</li>
                            <li><span className="fw-bold">Powerful Analytics</span>: Access aggregate data on potential DRE sites, total connections, and other feasibility indicators to generate crucial market insights.</li>
                            <li><span className="fw-bold">Public Accessibility</span>: All settlement data is available for download.</li>
                        </ul>

                        <p><a className="btn btn-navy-blue" href="/static/DRE-Atlas-Technical-Documentation.pdf">ACCESS TECHNICAL REPORT</a></p>

                      <p>Commissioned by ESMAP and IFC, and powered by VIDA’s technology, the DRE Atlas is an invaluable tool for developers, investors, donors, government officials, and researchers worldwide, offering unprecedented access to high-resolution data necessary for electrification planning in an interactive, map-based online platform. For any inquiries and potential collaboration please contact the development team:</p>

                        <ul>
                            <li>
                                <span className="fw-bold">The World Bank and ESMAP:</span> Ashish Shrestha – <a href="mailto:ashrestha1@worldbank.org">ashrestha1@worldbank.org</a>
                            </li>
                            <li>
                                <span className="fw-bold">The IFC:</span> Yann Tanvez – <a href="mailto:ytanvez@ifc.org">ytanvez@ifc.org</a>
                            </li>
                            <li>
                                <span className="fw-bold">VIDA Data Solutions Leads:</span> Malin Fischer and Jessica La Costa – <a href="mailto:malin@vida.place">malin@vida.place</a>, <a href="mailto:jess@vida.place">jess@vida.place</a>
                            </li>
                        </ul>
                    </div>
            </div>
            <div className="about-image-section">
                <div className="image-wrapper">
                <img
                alt="Illustration of diverse communities and global connections"
                src={AboutImg}
                className="home-landing-image"
                />
                </div>
            </div>
        </div>
        <div id="about-logo-section">  
            <img  
                alt="ESMAP Logo"  
                src={ESMAPLogoWhite}  
                className="img-fluid bottom-logo"  
            />  
            <img  
                alt="World Bank Group Blue Logo"  
                src={WBGLogoWhite}  
                className="img-fluid bottom-logo-wbg"  
            />  
            <img  
                alt="World Bank Group Blue Logo"  
                src={VidaLogoWhite}  
                className="img-fluid bottom-logo-vida"  
            />  
        </div>  
     </Layout>  
   );  
 }
